import React, { ReactElement } from 'react';

import Head from 'next/head';
import { useRouter } from 'next/router';
function HeadMeta({
  pageDescription,
  pageTitle,
}: {
  pageDescription: string;
  pageTitle: string;
}): ReactElement {
  const site = 'https://onark.app';
  const canonicalURL = site + useRouter().asPath;
  const description =
    pageDescription ||
    "OnArk: Your Church Classes On Demand. Don't reinvent your classes. Make them accessible online.";

  const title = pageTitle || 'OnArk | Church Classes On Demand';

  return (
    <Head>
      <meta charSet="utf-8" />

      <title>{title}</title>
      <meta content={title} name="twitter:title" />
      <meta content={title} property="og:title" />

      <meta content={description} name="twitter:card" />
      <meta content={description} name="description" />
      <meta content={description} name="twitter:description" />
      <meta content={description} property="og:description" />

      <meta
        content="https://onark.app/favicon/apple-icon-152x152.png"
        name="twitter:image"
      />
      <meta content="@onark" name="twitter:site" />
      <meta content="website" property="og:type" />
      <meta content="en_US" property="og:locale" />
      <meta content="OnArk" property="og:site_name" />
      <meta content={canonicalURL} property="og:url" />
      <link href={canonicalURL} rel="canonical" />
      <meta content="IE=edge" httpEquiv="X-UA-Compatible" />
      <meta
        content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"
        name="viewport"
      />
      {/* 
      <link
        href="/favicon/apple-icon-57x57.png"
        rel="apple-touch-icon"
        sizes="57x57"
      />
      <link
        href="/favicon/apple-icon-60x60.png"
        rel="apple-touch-icon"
        sizes="60x60"
      />
      <link
        href="/favicon/apple-icon-72x72.png"
        rel="apple-touch-icon"
        sizes="72x72"
      />
      <link
        href="/favicon/apple-icon-76x76.png"
        rel="apple-touch-icon"
        sizes="76x76"
      />
      <link
        href="/favicon/apple-icon-114x114.png"
        rel="apple-touch-icon"
        sizes="114x114"
      />
      <link
        href="/favicon/apple-icon-120x120.png"
        rel="apple-touch-icon"
        sizes="120x120"
      />
      <link
        href="/favicon/apple-icon-144x144.png"
        rel="apple-touch-icon"
        sizes="144x144"
      />
      <link
        href="/favicon/apple-icon-152x152.png"
        rel="apple-touch-icon"
        sizes="152x152"
      />
      <link
        href="/favicon/apple-icon-180x180.png"
        rel="apple-touch-icon"
        sizes="180x180"
      />
*/}
      <link
        key="favicon"
        href="/favicon/favicon-96x96.png"
        rel="icon"
        type="image/png"
      />
      {/* 
      <link href="/favicon/manifest.json" rel="manifest" />
      */}
      <meta content="#ffffff" name="msapplication-TileColor" />
      <meta content="/ms-icon-144x144.png" name="msapplication-TileImage" />
      <meta content="#ffffff" name="theme-color" />
    </Head>
  );
}

export default HeadMeta;
